<template>
  <v-layout>

   <v-navigation-drawer
     v-model="drawer"
     :mini-variant="mini"
     absolute
     light
     temporary
   >
     <v-list class="pt-0" dense>
       <v-divider light></v-divider>
       <v-toolbar-title>Navigation</v-toolbar-title>
       <v-list-tile
         v-for="item in items"
         :key="item.title"
         :to="item.nav"
       >
         <v-list-tile-action>
           <v-icon>{{ item.icon }}</v-icon>
         </v-list-tile-action>

         <v-list-tile-content>
           <v-list-tile-title>{{ item.title }}</v-list-tile-title>
         </v-list-tile-content>
       </v-list-tile>
     </v-list>
   </v-navigation-drawer>



  <!--   <v-avatar>
       <v-img :src="require('../assets/avatar.jpg')"></v-img>
     </v-avatar>-->
      <!-- <h1 v-bind:style="{ paddingLeft: '70px' }" class="title-padding">Witch of the Vale</h1> -->
      <v-spacer></v-spacer>

      <v-btn
        class="hidden-md-and-up"
        @click.stop="drawer = !drawer"
      >
      <v-icon>menu</v-icon>

      </v-btn>
      <v-btn-toggle mandatory class="hidden-sm-and-down" v-model="selectedPage">
        <v-btn value="home" large to="/" >
          <span>Home</span>
          <v-icon>home</v-icon>
        </v-btn>
        <v-btn value="events" large to="/events">
            <span>Events</span>
            <v-icon>event</v-icon>
        </v-btn>
        <v-btn value="music" large to="/music">
          <span>Music</span>
          <v-icon>music_note</v-icon>
        </v-btn>

        
        <!-- <v-btn value="gallery" large to="/gallery">
          <span>Gallery</span>
          <v-icon>photo_library</v-icon>
        </v-btn> -->

        <v-btn value="store" large to="/store">
          <span>Merch</span>
          <v-icon>store_mall_directory</v-icon>
        </v-btn>

        <v-btn value="press" large to="/press">
          <span>Press</span>
          <v-icon>camera</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-layout>
</template>

<script>
export default {

  created() {
    //this.baseaccount = this.$route.params.baseaccount;
  },
  //currentPage: 'lol',
  data() {
    return {
    //  selectedPage: this.$route.name,

      // currentPage: ''
      selectedPage: '',
      drawer: null,
      items: [
        { title: 'Home', icon: 'dashboard', nav: "/" },
        { title: 'Events', icon: 'event', nav:"/events" },
        { title: 'Music', icon: 'music_note', nav:"/music" },
        { title: 'Merch', icon: 'store_mall_directory', nav:"/store" },
        { title: 'Press', icon: 'camera', nav:"/press" },
      //  { title: 'Gallery', icon: 'photo_library', nav:"/gallery" },
      ],
      mini: false,
      right: null

    }
  }
}
</script>

<style>
  a { text-decoration: none; }
  .title-padding: {
    padding-left: 15px;
  }
</style>
